// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import RetreatsPage from "../pages/Retreats/Retreats";
const __wvcRoutePaths = ["/RetreatsPage", "/retreats"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutmepage", "angebote", "angebotepage", "chakra-heilung", "chakrahealingpage", "contactpage", "homepage", "kontakt", "post", "reiki-therapie", "reikitherapypage", "retreats", "retreatspage", "startseite", "uber-mich"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<RetreatsPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<RetreatsPage />} />
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
